/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 28/03/2023.
 */
import { TimePicker } from 'antd'
import React, { useEffect, useMemo } from 'react'
import { FormLabel } from './FormLabel'
import { get, UseFormReturn } from 'react-hook-form'
import { TimeFormConfigObject } from '../../Types'
import dayjs from 'dayjs'

type Props = { formHook: UseFormReturn; data: TimeFormConfigObject }

const format = 'HH:mm'

const convertFormat = (value) => {
  return value
}

export const FormTime = ({ data, formHook }: Props) => {
  const {
    register,
    setValue,
    getValues,
    unregister,
    clearErrors,
    formState: { errors },
  } = formHook

  const outputFormat = data.outputFormat ? data.outputFormat : 'h:m'

  const errorState = get(errors, data.id)
  const errorMessage: string =
    errorState && errorState.message ? (errorState.message as string) : (data.errorMsg as string)

  useEffect(() => {
    register(data.id, { ...data.validation, value: convertFormat(data.value) || null })
  }, [register, data.id, data.validation, data.value])

  useEffect(() => {
    return () => {
      unregister(data.id)
    }
  }, [unregister, data.id])

  const handleChange = (value, time) => {
    clearErrors()
    if (outputFormat === 'minutes') {
      const minutes = value.get('h') * 60 + value.get('m')
      const outputValue = outputFormat === 'minutes' ? minutes : time
      setValue(data.id, outputValue)
    }

    if (outputFormat === 'HH:mm') {
      setValue(data.id, time)
    }

    //
    // the clearErrors acts a magic bullet, because it keeps the component in sync
    // otherwise the selected value is not show
    //

    //setState(value)
  }

  const currentValue = getValues(data.id) ? getValues(data.id) : data.value

  const getCurrentValue = useMemo(() => {
    if (!currentValue) {
      return currentValue ? dayjs(currentValue, format) : null
    }

    if (outputFormat === 'minutes') {
      const d = new Date()
      d.setHours(0, currentValue, 0, 0)
      return currentValue ? dayjs(d) : null
    }

    if (outputFormat === 'HH:mm') {
      return currentValue ? dayjs(currentValue, format) : null
    }

    throw new Error('Invalid outputFormat')
  }, [currentValue, outputFormat])

  return (
    <div className={` ${data.className} py-2`}>
      <FormLabel label={data.label}>
        {data.postfix ? (
          <p>
            {data.label} <span className="opacity-75 p-small">{data.postfix}</span>
          </p>
        ) : null}
      </FormLabel>

      <TimePicker
        className="w-100"
        //defaultValue={dayjs('00:00', 'HH:mm')}
        value={getCurrentValue}
        placeholder={data.placeholder}
        format={format}
        minuteStep={15}
        showNow={false}
        onChange={handleChange}
        status={errorState ? 'error' : ''}
        changeOnBlur={true}
      />
      {errorState ? <div className="p-small text-danger">{errorMessage}</div> : null}
    </div>
  )
}
